"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VirtualBackgroundOptions = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _underscore = require("underscore");
var _VirtualBackground = require("@studio/constants/VirtualBackground");
var _FormLabel = require("../../FormLabel/FormLabel");
var _JoinComponent = require("../JoinComponent.styled");
var _VirtualBackgroundUpload = _interopRequireDefault(require("../VirtualBackgroundUpload/VirtualBackgroundUpload"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
/**
 * VirtualBackgroundOptions component for selecting virtual background settings.
 */
var VirtualBackgroundOptions = exports.VirtualBackgroundOptions = function VirtualBackgroundOptions(_ref) {
  var userBackground = _ref.userBackground,
    updateUserBackground = _ref.updateUserBackground,
    uploadUserVirtualBackground = _ref.uploadUserVirtualBackground,
    virtualBackground = _ref.virtualBackground,
    resetUserVirtualBackground = _ref.resetUserVirtualBackground,
    isCustomBackgroundProcessing = _ref.isCustomBackgroundProcessing;
  var handleBackgroundOptionChange = (0, _react.useCallback)((0, _underscore.debounce)(function (option) {
    if (isCustomBackgroundProcessing || option === userBackground) {
      return;
    }
    updateUserBackground(option);
  }, 300, true), [isCustomBackgroundProcessing, userBackground, updateUserBackground]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "pt-4"
  }, /*#__PURE__*/_react["default"].createElement(_FormLabel.FormLabel, {
    id: "virtualBackground",
    label: "Virtual Background",
    labelFor: "virtualBackground",
    useAs: "span"
  }), /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledButtonGroup, null, /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledButton, {
    "aria-disabled": isCustomBackgroundProcessing,
    "data-testid": userBackground === _VirtualBackground.BACKGROUND_OPTIONS.NONE ? 'none-background-selected' : 'none-background',
    type: "button",
    active: userBackground === _VirtualBackground.BACKGROUND_OPTIONS.NONE,
    onClick: function onClick() {
      return handleBackgroundOptionChange(_VirtualBackground.BACKGROUND_OPTIONS.NONE);
    },
    "aria-label": "No virtual background"
  }, /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledText, null, "None")), /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledButton, {
    "aria-disabled": isCustomBackgroundProcessing,
    "data-testid": userBackground === _VirtualBackground.BACKGROUND_OPTIONS.BLUR ? 'blur-background-selected' : 'blur-background',
    type: "button",
    active: userBackground === _VirtualBackground.BACKGROUND_OPTIONS.BLUR,
    isBlur: true,
    onClick: function onClick() {
      return handleBackgroundOptionChange(_VirtualBackground.BACKGROUND_OPTIONS.BLUR);
    },
    "aria-label": "Blur background"
  }, /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledText, null, "Blur")), /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledButton, {
    "aria-disabled": isCustomBackgroundProcessing,
    "data-testid": userBackground === _VirtualBackground.BACKGROUND_OPTIONS.CUSTOM ? 'custom-background-selected' : 'custom-background',
    type: "button",
    active: userBackground === _VirtualBackground.BACKGROUND_OPTIONS.CUSTOM,
    onClick: function onClick() {
      return handleBackgroundOptionChange(_VirtualBackground.BACKGROUND_OPTIONS.CUSTOM);
    },
    "aria-label": "Custom background"
  }, /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledText, null, "Custom"))), userBackground === _VirtualBackground.BACKGROUND_OPTIONS.CUSTOM && /*#__PURE__*/_react["default"].createElement(_VirtualBackgroundUpload["default"], {
    "aria-disabled": isCustomBackgroundProcessing,
    uploadUserVirtualBackground: uploadUserVirtualBackground,
    virtualBackground: virtualBackground,
    resetUserVirtualBackground: resetUserVirtualBackground,
    isCustomBackgroundProcessing: isCustomBackgroundProcessing,
    updateUserBackground: updateUserBackground
  }));
};
VirtualBackgroundOptions.propTypes = {
  userBackground: _propTypes["default"].oneOf([_VirtualBackground.BACKGROUND_OPTIONS.NONE, _VirtualBackground.BACKGROUND_OPTIONS.BLUR, _VirtualBackground.BACKGROUND_OPTIONS.CUSTOM]).isRequired,
  updateUserBackground: _propTypes["default"].func.isRequired,
  uploadUserVirtualBackground: _propTypes["default"].func,
  virtualBackground: _propTypes["default"].object,
  resetUserVirtualBackground: _propTypes["default"].func,
  isCustomBackgroundProcessing: _propTypes["default"].bool
};